import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../lib/axios";
import { API_PORTAL_URL } from "../../../lib/config";
import { ErrorToast } from "../../../components/common/Toast";

export const getAllActiveWeddingVenues = createAsyncThunk(
  "WeddingVenues/FindAllActiveWeddingVenues",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/WeddingVenues/FindAllActiveWeddingVenues`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Wedding Venues:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getWeddingVenueByURL = createAsyncThunk(
  "WeddingVenues/FindByURLWeddingVenues",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/WeddingVenues/FindByURLWeddingVenues`,
        { URL },
      );
      return response.data?.Data as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Wedding Venue Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
